import React from "react";

export default function Partners() {
  return (
    <div style={{ padding: "40px", maxWidth: "800px", margin: "0 auto" }}>
      <h1>I nostri partner</h1>
      <p>
        Partner affidabili per il servizio veicoli e supporto stradale.
        Altri partner saranno aggiunti una volta approvati.
      </p>

      <h2>Partner approvato</h2>

      <div
        style={{
          marginTop: "20px",
          padding: "20px",
          border: "1px solid #ddd",
          borderRadius: "8px",
          background: "#f9f9f9",
        }}
      >
        <h3>Premierline – FCA Authorised</h3>
        <p>Accedi al partner approvato tramite il link ufficiale AWIN.</p>

        <a
          href="https://www.awin1.com/cread.php?s=3526910&v=16315&q=479144&r=2959523"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            marginTop: "10px",
            padding: "12px 20px",
            background: "#ff9900",
            color: "#000",
            fontWeight: "bold",
            borderRadius: "6px",
            textDecoration: "none",
          }}
        >
          Accedi al Partner
        </a>
      </div>
    </div>
  );
}
